import { Typography } from "@mui/material";
import type { FC } from "react";
import { useMemo } from "react";
import { SegmentedMessage } from "sms-segments-calculator";

interface Props {
  readonly content: string;
}

const CHARACTER_FORMS: Record<Intl.LDMLPluralRule, string> = {
  zero: "znaków",
  one: "znak",
  two: "znaki",
  few: "znaki",
  many: "znaków",
  other: "znaków",
};

const pluralRules = new Intl.PluralRules("pl");

/** Billable SMS length: characters in the chosen encoding, number of SMS segments and the encoding itself. */
const SmsCounter: FC<Props> = ({ content }) => {
  const message = useMemo(() => new SegmentedMessage(content), [content]);
  const characters = message.numberOfCharacters;
  const segments = content.length === 0 ? 0 : message.segmentsCount;
  const nonGsmCharacters = message.encodingName === "UCS-2" ? message.getNonGsmCharacters() : [];

  return (
    <>
      <Typography variant="caption" color="text.secondary" component="div">
        {`${characters} ${CHARACTER_FORMS[pluralRules.select(characters)]} · ${segments} SMS · ${message.encodingName}`}
      </Typography>
      {nonGsmCharacters.length > 0 && (
        <Typography variant="caption" color="warning.main" component="div">
          {`Znaki spoza alfabetu GSM (${nonGsmCharacters.join(", ")}) skracają SMS do 70 znaków.`}
        </Typography>
      )}
    </>
  );
};

export default SmsCounter;
